// extracted by mini-css-extract-plugin
export default {"header":"student_header__zsRKp"};